import React from 'react';

function TwitterIcon({ className = '' }) {
	return (
		<svg
			className={className}
			width='32'
			height='32'
			viewBox='0 0 38 38'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<circle cx='19' cy='19' r='19' fill='#F8F5EF'></circle>
			<g clipPath='url(#clip0_7022_92891)'>
				<path
					d='M28.0574 14.3574C28.9846 13.699 29.7645 12.8773 30.4001 11.9311V11.9301C29.5517 12.3016 28.6492 12.5486 27.7068 12.6683C28.6758 12.0897 29.4159 11.1806 29.7636 10.0852C28.8601 10.6239 27.8626 11.0039 26.7996 11.2167C25.9417 10.3028 24.7191 9.73752 23.3853 9.73752C20.7975 9.73752 18.7141 11.838 18.7141 14.4125C18.7141 14.783 18.7455 15.1392 18.8224 15.4784C14.9369 15.2884 11.4979 13.4264 9.18755 10.5887C8.78475 11.2889 8.54725 12.0897 8.54725 12.9514C8.54725 14.5702 9.3804 16.0047 10.6239 16.8359C9.8725 16.8217 9.13625 16.6032 8.5121 16.2602V16.3115C8.5121 18.583 10.1318 20.4697 12.257 20.9048C11.876 21.0093 11.4618 21.0587 11.0315 21.0587C10.7322 21.0587 10.4301 21.0416 10.147 20.9789C10.7522 22.8295 12.4717 24.1908 14.5142 24.2355C12.9239 25.479 10.9042 26.2286 8.71825 26.2286C8.3354 26.2286 7.96775 26.2115 7.6001 26.1649C9.6711 27.4997 12.124 28.2625 14.7707 28.2625C23.0195 28.2625 28.3956 21.3807 28.0574 14.3574Z'
					fill='#CF004F'
				></path>
			</g>
			<defs>
				<clipPath id='clip0_7022_92891'>
					<rect
						width='22.8'
						height='22.8'
						fill='white'
						transform='translate(7.6001 7.60001)'
					></rect>
				</clipPath>
			</defs>
		</svg>
	);
}

export default TwitterIcon;
